import React from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleViewProjects = () => {
    navigate('/projects');
  };

  const handleDownloadResume = () => {
    const link = document.createElement('a');
    link.href = '/assets/resume.pdf';
    link.download = 'Sarah_Mitchell_Resume.pdf';
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);
  };

  const handleLinkedInClick = () => {
    window.open('https://www.linkedin.com/in/joseph-graziano-34a44530/', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="relative min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="absolute inset-0 opacity-20">
        <Image
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1071963b4-1767396331290.png"
          alt="Modern office workspace with laptop and coffee on wooden desk with natural lighting from large windows"
          className="w-full h-full object-cover" />

      </div>
      
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/50 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <div className="inline-block mb-4 md:mb-6">
              <span className="px-4 py-2 bg-accent/20 text-accent rounded-full text-sm md:text-base font-medium pl-0">
                Threat Analyst Engineer & Software Engineer & Sales Engineer
              </span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 md:mb-6">
              Hi, I'm <span className="text-accent">Joe Graziano</span>
            </h1>
            
            <p className="text-base md:text-lg lg:text-xl text-gray-300 mb-6 md:mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              Proven expertise in threat analysis and detection engineering, delivering high-impact results at scale.
With 15+ years of experience combating email-borne threats including phishing, malware, BEC, and spam.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                variant="default"
                size="lg"
                iconName="Linkedin"
                iconPosition="left"
                onClick={handleLinkedInClick}
                className="w-full sm:w-auto ml-0 pl-8">
                View Profile
              </Button>
            </div>

            <div className="mt-8 md:mt-10 flex items-center gap-6 justify-center lg:justify-start">
              <div className="text-center">
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">15+</div>
                <div className="text-xs md:text-sm text-gray-400 mt-1">Years Experience</div>
              </div>
              <div className="w-px h-12 bg-gray-600"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">10m+</div>
                <div className="text-xs md:text-sm text-gray-400 mt-1">MalSpam Emails Blocked</div>
              </div>
              <div className="w-px h-12 bg-gray-600"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">100k+</div>
                <div className="text-xs md:text-sm text-gray-400 mt-1">Protected Clients</div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-accent/20 rounded-full blur-3xl"></div>
              <div className="relative w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 rounded-full overflow-hidden border-4 md:border-8 border-accent/30 shadow-2xl">
                <Image
                  src="/assets/images/download-1769539104139.png"
                  alt="Professional portrait of confident woman with long brown hair wearing white blazer against neutral background with warm lighting"
                  className="w-full h-full object-cover" />

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;